import { Dialog, Icon } from '@mui/material';
import { FunctionComponent, useEffect, useState } from 'react';

import { UnlockedSerie } from '../../../shared/api/request';
import '../../../shared/css/ui.css';

interface UnlockSuccessDialogProps {
  series: UnlockedSerie[] | null;
  onClose: () => void;
  onOpenSerie: (serie: UnlockedSerie) => void;
}

const UnlockSuccessDialog: FunctionComponent<UnlockSuccessDialogProps> = ({ series: seriesProp, onClose, onOpenSerie }) => {
  // Keep the last content displayed while the dialog plays its closing transition
  const [series, setSeries] = useState<UnlockedSerie[] | null>(seriesProp);
  useEffect(() => {
    if (seriesProp) setSeries(seriesProp);
  }, [seriesProp]);

  const count = series?.length ?? 0;

  const getMessage = () => {
    if (count === 0) return 'Vos contenus sont maintenant disponibles dans votre bibliothèque.';
    if (count === 1) return 'Cette série est maintenant débloquée. Vous la retrouverez à tout moment dans votre bibliothèque.';
    return `Ces ${count} séries sont maintenant débloquées. Vous les retrouverez à tout moment dans votre bibliothèque.`;
  };

  return (
    <Dialog
      open={seriesProp !== null}
      onClose={onClose}
      aria-labelledby="nbk-unlock-success-title"
      aria-describedby="nbk-unlock-success-text"
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          backgroundColor: '#2B1A59',
          backgroundImage: 'none',
          color: 'white',
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          margin: '16px',
          width: 'calc(100% - 32px)',
        },
      }}>
      <div className="nbk-dialog">
        <button type="button" className="nbk-dialog__close" onClick={onClose} aria-label="Fermer">
          <Icon>close</Icon>
        </button>

        <div className="nbk-dialog__icon" aria-hidden="true">
          <Icon>check</Icon>
        </div>
        <h2 id="nbk-unlock-success-title" className="nbk-dialog__title">
          Code validé !
        </h2>
        <p id="nbk-unlock-success-text" className="nbk-dialog__text">
          {getMessage()}
        </p>

        {series && count > 0 ? (
          <ul className={`nbk-dialog__series${count === 1 ? ' nbk-dialog__series--single' : ''}`}>
            {series.map(s => (
              <li key={s.idSerie}>
                <button type="button" className="nbk-dialog__serie" onClick={() => onOpenSerie(s)}>
                  <img src={s.img} alt="" loading="lazy" />
                  <span className="nbk-dialog__serie-name">{s.name}</span>
                </button>
              </li>
            ))}
          </ul>
        ) : null}

        <div className="nbk-dialog__actions">
          {series && count === 1 ? (
            <button type="button" className="nbk-btn nbk-btn--primary" onClick={() => onOpenSerie(series[0])} autoFocus>
              Commencer la lecture
            </button>
          ) : null}
          <button type="button" className="nbk-btn nbk-btn--ghost" onClick={onClose} autoFocus={count !== 1}>
            {count === 1 ? 'Plus tard' : 'Fermer'}
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default UnlockSuccessDialog;
